import { createCloudRunAxios } from './axios';
import { getEAlertErrorMessage } from './eAlerts';

const remiApi = createCloudRunAxios('remi-api');

interface BulkEAlertRequest {
  bulk: boolean;
  organization_id: string;
  tag: string;
  interval: 'daily' | 'weekly' | 'bi-weekly';
  ignore_tag_filter?: boolean;
  // Location parameters (optional)
  city?: string;
  cities?: string[];
  state?: string;
  subdivision?: string;
  // Search parameters (optional)
  q?: string;
  // Property specifications (optional)
  bedrooms?: number;
  bathrooms?: number;
  min_price?: number;
  max_price?: number;
  property_type?: string;
  propertysubtype?: string;
  status?: string;
  // Boolean features (optional)
  waterfront?: boolean;
  pool?: boolean;
  basement?: boolean;
  garage?: boolean;
  // Square footage (optional)
  sqft_min?: number;
  sqft_max?: number;
}

export const registerBulkEAlert = async (data: BulkEAlertRequest): Promise<unknown> => {
  try {
    const response = await remiApi.post('/api/v1/ealert/register', data);
    return response.data;
  } catch (error) {
    throw new Error(getEAlertErrorMessage(error, 'Failed to register bulk eAlert'));
  }
};

interface BulkUnsubscribeEAlertRequest {
  organization_id: string;
  tag?: string;
  ignore_tag_filter?: boolean;
}

interface BulkUnsubscribeEAlertResponse {
  success: boolean;
  organization_id: string;
  tag?: string;
  contacts_found: number;
  contacts_unsubscribed: number;
  failed_contacts: number;
  processing_time: string;
  failed_contacts_details?: Array<{
    contact_id: string;
    error: string;
  }>;
}

export const bulkUnsubscribeEAlert = async (
  data: BulkUnsubscribeEAlertRequest
): Promise<BulkUnsubscribeEAlertResponse> => {
  try {
    const response = await remiApi.post<BulkUnsubscribeEAlertResponse>('/api/v1/ealert/bulk-unsubscribe', data);
    return response.data;
  } catch (error) {
    throw new Error(getEAlertErrorMessage(error, 'Failed to bulk unsubscribe eAlerts'));
  }
};

// Bulk update eAlert filters
interface BulkUpdateEAlertFiltersRequest {
  bulk: boolean;
  organization_id: string;
  tag: string;
  ignore_tag_filter?: boolean;
  // Location parameters (optional)
  city?: string;
  cities?: string[];
  state?: string;
  subdivision?: string;
  // Search parameters (optional)
  q?: string;
  // Property specifications (optional)
  bedrooms?: number;
  bathrooms?: number;
  min_price?: number;
  max_price?: number;
  property_type?: string;
  propertysubtype?: string;
  status?: string;
  // Boolean features (optional)
  waterfront?: boolean;
  pool?: boolean;
  basement?: boolean;
  garage?: boolean;
  // Square footage (optional)
  sqft_min?: number;
  sqft_max?: number;
}

interface BulkUpdateEAlertFiltersResponse {
  success: boolean;
  bulk: boolean;
  organization_id: string;
  tag: string;
  ignore_tag_filter: boolean;
  total_contacts_found: number;
  contacts_with_ealerts: number;
  filters_updated: number;
  failed_updates: number;
  filters: Record<string, unknown>;
  processing_time: string;
  message: string;
  failed_contact_details?: Array<{
    contact_id: string;
    error: string;
  }>;
}

export const bulkUpdateEAlertFilters = async (
  data: BulkUpdateEAlertFiltersRequest
): Promise<BulkUpdateEAlertFiltersResponse> => {
  try {
    const response = await remiApi.post<BulkUpdateEAlertFiltersResponse>('/api/v1/ealert/update', data);
    return response.data;
  } catch (error) {
    throw new Error(getEAlertErrorMessage(error, 'Failed to bulk update eAlert filters'));
  }
};
